export const SAVE_IMPORT_WIZARD = 'SAVE_IMPORT_WIZARD';
export type SAVE_IMPORT_WIZARD = typeof SAVE_IMPORT_WIZARD;

export interface SaveImportWizard {
    type: SAVE_IMPORT_WIZARD;
}

export function saveImportWizardAction(): SaveImportWizard {
    return {
        type: SAVE_IMPORT_WIZARD
    };
}
